
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
import { DocumentationLayout as _Layout } from '@/layouts/DocumentationLayout'
import { ContentsLayout as _Default } from '@/layouts/ContentsLayout'
import { Heading } from '@/components/Heading'
import { TipGood, TipBad } from '@/components/Tip'
import { CodeSample } from '@/components/CodeSample'
const Layout = _Layout;
const meta = {
  "id": "appcustomisation",
  "title": "App customisation",
  "sidebar_label": "Customising App"
};
const slug = 'appcustomisation';
const tableOfContents = [{
  "title": "Once pre-launch customisations",
  "slug": "once-pre-launch-customisations",
  "children": []
}, {
  "title": "App Primary Color",
  "slug": "app-primary-color",
  "children": []
}, {
  "title": "Logo / Splash Screen",
  "slug": "logo-splash-screen",
  "children": []
}, {
  "title": "App Icon / Favicon",
  "slug": "app-icon-favicon",
  "children": []
}, {
  "title": "Onboarding Images",
  "slug": "onboarding-images",
  "children": []
}, {
  "title": "Top bar / Tool bar text",
  "slug": "top-bar-tool-bar-text",
  "children": []
}, {
  "title": "Main Action Icon (called as Sell Icon)",
  "slug": "main-action-icon-called-as-sell-icon",
  "children": []
}, {
  "title": "Important Texts",
  "slug": "important-texts",
  "children": []
}, {
  "title": "URL Changes",
  "slug": "url-changes",
  "children": []
}, {
  "title": " Listing submission ",
  "slug": "listing-submission",
  "children": []
}, {
  "title": " Listing Categories Section ",
  "slug": "listing-categories-section",
  "children": []
}, {
  "title": " Listing Detail Page",
  "slug": "listing-detail-page",
  "children": []
}, {
  "title": " Promotions  ",
  "slug": "promotions",
  "children": []
}, {
  "title": " Account Creation ",
  "slug": "account-creation",
  "children": []
}, {
  "title": " Collection Widget ",
  "slug": "collection-widget",
  "children": []
}, {
  "title": " Groups ",
  "slug": "groups",
  "children": []
}, {
  "title": " Top Header ",
  "slug": "top-header",
  "children": []
}, {
  "title": " SuperApp Widget ",
  "slug": "super-app-widget",
  "children": []
}, {
  "title": " Navigation Bar / Footer ",
  "slug": "navigation-bar-footer",
  "children": []
}, {
  "title": " Social Feed ",
  "slug": "social-feed",
  "children": []
}, {
  "title": " Search Screen ",
  "slug": "search-screen",
  "children": []
}, {
  "title": " Branch Invite ",
  "slug": "branch-invite",
  "children": []
}, {
  "title": " Chat screens ",
  "slug": "chat-screens",
  "children": []
}];
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Highlight = makeShortcode("Highlight");
const layoutProps = {
  Layout,
meta,
slug,
tableOfContents
};
const MDXLayout = _Default
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">







    <p>{`As a platform owner, you may wish to customise your platform UI, functionalities, wordings, etc. We have shared below on what sort of features you can customise by yourself, what features need our developer assistance, what features cannot be customised. If there is anything which is not listed here, feel free to message us on the chat. `}</p>
    <p>{`Note: This is applicable for customers who purchased apps built by Tradly. `}</p>
    <_Heading level={2} id={"once-pre-launch-customisations"} nextElement={{
      "type": "paragraph"
    }}>Once pre-launch customisations</_Heading>
    <p>{`You will be able to make the below customisation before the app gets published in the respective stores. `}</p>
    <ul {...{
      "className": "contains-task-list",
      "role": "list"
    }}>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`App Icon, Logo`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Important texts that need to be changed`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`Login method and Login API-Keys & Credentials`}</li>
      <li parentName="ul" {...{
        "className": "task-list-item"
      }}><input parentName="li" {...{
          "type": "checkbox",
          "checked": false,
          "disabled": true
        }}></input>{` `}{`And the below things based on the details below`}</li>
    </ul>
    <_Heading level={2} id={"app-primary-color"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": true
    }}>App Primary Color</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">
        <p parentName="li">{`All the things you see as primary color (mostly in our demo apps, you will find green) can be changed to your brand primary color. The current color: 13B58C`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`You can `}<a parentName="p" {...{
            "href": "https://www.figma.com/file/CVL55dJAeCZm09qpepE9XQ/TradlyPlatform-DesignKit?node-id=0%3A1"
          }}>{`duplicate our design template from Figma`}</a>{` and apply different color using our design palette to see how it’s going to look`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`@AgencyPartners: You can also use the components to build your UI or take it as reference on how each thing structured. `}</p>
      </li>
    </ul>
    <_Heading level={2} id={"logo-splash-screen"} nextElement={{
      "type": "paragraph"
    }}>Logo / Splash Screen</_Heading>
    <p>{`Splash-screen which is the first screen will have a background color (the brand primary color) and your logo. See below for reference.`}</p>
    <img src="/img/splash1.png" alt="splash Screen" width="700" />
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Transparent background`}</li>
      <li parentName="ul">{`Dimension: 150*150 or similar range if the logo is not square`}</li>
      <li parentName="ul">{`IOS: Upload your logo for iOS in PNG format with 3 variance 1PX, 2PX & 3PX. `}</li>
      <li parentName="ul">{`Android: SVG format `}</li>
    </ul>
    <_Heading level={2} id={"app-icon-favicon"} nextElement={{
      "type": "paragraph"
    }}>App Icon / Favicon</_Heading>
    <p>{`App Icon used in push notifications alerts, app launch icon and also which are visible when users are searching for your app on play-store and App Store. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.apple.com/design/human-interface-guidelines/ios/icons-and-images/app-icon"
        }}>{`iOS Specification`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.android.com/google-play/resources/icon-design-specifications"
        }}>{`Android Specification`}</a></li>
      <li parentName="ul">{`Upload both of them according to the spec. Uploading wrong spec can delay the launch. `}</li>
    </ul>
    <p><strong parentName="p">{`Quick Tip`}</strong></p>
    <p>{`Since app have different resolutions, you need to provide app icons in different sizes. For that, you can use a third-party tool. Here is how to use the ‘Make App Icon’ tool.`}</p>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Go to `}<a parentName="li" {...{
          "href": "https://makeappicon.com/"
        }}>{`https://makeappicon.com/`}</a></li>
      <li parentName="ol">{`Upload your app icon (PNG file)`}</li>
      <li parentName="ol">{`It will ask few questions. You can skip those questions.`}</li>
      <li parentName="ol">{`At the end, it will be your email ID to send app icon files. (Note: you can untick the newsletter)`}</li>
      <li parentName="ol">{`Zip file will be sent to your email ID`}</li>
      <li parentName="ol">{`Download that zip file and upload in “SuperAdmin > App Customisation”`}</li>
    </ol>
    <img src="/img/icon-folder.png" alt="Icon folder Structure" width="200" />
    <p>{`Results of using Makeappicon
`}<img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/61427976/142882001-d5ac9bd9-593e-4d89-a97f-1c4a7dd565c8.png",
        "alt": "image"
      }}></img>{`
`}<img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/61427976/142882034-19a383d4-a9c0-4baa-8799-dffad66e32bb.png",
        "alt": "image"
      }}></img></p>
    <p>{`Result of using Make app icon
Result of using Make app icon
:::danger Attention
You need to attach the ZIP exactly as how you download from the makeappicon. Avoid creating your folder structure, your build generation would be failed.
:::`}</p>
    <_Heading level={2} id={"onboarding-images"} nextElement={{
      "type": "paragraph"
    }}>Onboarding Images</_Heading>
    <p>{`This is getting started images before user signup. You can use this to educate on what your app can do or explaining other important features of the app. In the below image, red highlighted section. `}</p>
    <img src="/img/onboarding.png" alt="onboarding" width="200" />
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`iOS & Android Specification: - Upload in PNG format. `}</li>
      <li parentName="ul">{`Size: Less than 200KB per image for faster app load.`}</li>
    </ul>
    <p><strong parentName="p">{` Quick Tip `}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You can download open-source illustrations with your branding color from `}<a parentName="li" {...{
          "href": "https://undraw.co"
        }}>{`https://undraw.co`}</a></li>
    </ul>
    <_Heading level={2} id={"top-bar-tool-bar-text"} nextElement={{
      "type": "paragraph"
    }}>Top bar / Tool bar text</_Heading>
    <p>{`The top text in the tool. It is always your app name. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Update the app name in mobile config settings`}</li>
      <li parentName="ul">{`Color code of that text: default is white. Suggested to keep white if your primary color is dark. `}</li>
      <li parentName="ul">{`Default font: Montserrat. You can change font on request.`}</li>
    </ul>
    <_Heading level={2} id={"main-action-icon-called-as-sell-icon"} nextElement={{
      "type": "paragraph"
    }}>Main Action Icon (called as Sell Icon)</_Heading>
    <p>{`The main action you want to make user to do often. You can consider this as the main call to action, which will always be seen in the bottom nav bar. A simple + would be doable, but if you want to go more than that, you can change in SuperAdmin. `}</p>
    <img src="/img/navbar.png" alt="navbar" width="300" />
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`iOS & Android: PNG format `}</li>
      <li parentName="ul">{`Transparent background`}</li>
      <li parentName="ul">{`Dimension: 150px*150px`}</li>
    </ul>
    <_Heading level={2} id={"important-texts"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Important Texts</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Onboarding Screens Text: 5-10 Words line for 3 screens.`}</li>
      <li parentName="ul">{`Registration Page Text: Example: “Welcome to Brandname” or “Welcome to Brand name - Short tag line”`}</li>
    </ul>
    <_Heading level={2} id={"url-changes"} nextElement={{
      "type": "paragraph"
    }}>URL Changes</_Heading>
    <p>{`As a mandatory practice for you, you will need to update Privacy URL and T&C to make sure all the users are of your terms and conditions. Furthermore, the privacy URL to share how you’re going to use user’s private data.
`}<strong parentName="p">{`Mandatorily, these two things will be needed for AppStore and playstore listings submission.`}</strong></p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Privacy URL: example.com/terms-condition`}</li>
      <li parentName="ul">{`Terms & Condition URL: example.com/privacy-policy/`}</li>
    </ul>
    <_Heading level={2} id={"listing-submission"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#25c2a0" mdxType="Highlight"> Listing submission </Highlight></_Heading>
    <p>{`As a platform owner, you can manage what sort of fields needs to be in the listing submission page`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You can activate, deactivate certain fields`}</li>
      <li parentName="ul">{`You can add new attributes(fields) for all listings or specific attributes per listing category`}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/img/attributes.png",
        "alt": "attributes"
      }}></img></p>
    <_Heading level={2} id={"listing-categories-section"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#25c2a0" mdxType="Highlight"> Listing Categories Section </Highlight></_Heading>
    <p>{`As a platform owner, you can configure multiple parent categories and sub categories for 4 more levels from the superadmin panel`}</p>
    <p><img parentName="p" {...{
        "src": "/img/category.png",
        "alt": "Category"
      }}></img></p>
    <_Heading level={2} id={"listing-detail-page"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}><Highlight color="#25c2a0" mdxType="Highlight"> Listing Detail Page</Highlight></_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Listing detail page contents is dynamic based on the listing attributes configuration you make`}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/img/product-detail.png",
        "alt": "product-detail"
      }}></img></p>
    <_Heading level={2} id={"promotions"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#25c2a0" mdxType="Highlight"> Promotions  </Highlight></_Heading>
    <p>{`As a platform owner, you can manage your promotions from the superadmin panel. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Add new promotions for web and app separately`}</li>
      <li parentName="ul">{`Activate or Deactivate existing promotions`}</li>
      <li parentName="ul">{`Schedule time for promotions to be live`}</li>
      <li parentName="ul">{`You can link the promotions to Listing ID or just leave it as a static promotions`}</li>
    </ul>
    <p>{`Note: There is no limit for number of Promotions to be active`}</p>
    <p><img parentName="p" {...{
        "src": "/img/promobanner.png",
        "alt": "promotions"
      }}></img></p>
    <_Heading level={2} id={"account-creation"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}><Highlight color="#25c2a0" mdxType="Highlight"> Account Creation </Highlight></_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Platform owners can configure the fields need to be in account creation page`}</li>
      <li parentName="ul">{`Extra attributes can be added based on categories of account (Example:Grocery platform wants to have Shop, Farm, Home Garden)`}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/img/account-creation.png",
        "alt": "account-creation"
      }}></img></p>
    <_Heading level={2} id={"collection-widget"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#25c2a0" mdxType="Highlight"> Collection Widget </Highlight></_Heading>
    <p>{`You can have multiple collection widget on the home page. Example: Currently you can see below two widgets like “Stores to follow” an account widget and “Latest products” a listing widget.
`}<img parentName="p" {...{
        "src": "/img/collection-widget.png",
        "alt": "collection-widget"
      }}></img></p>
    <_Heading level={2} id={"groups"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#1877F2" mdxType="Highlight"> Groups </Highlight></_Heading>
    <p>{`As a platform owner, you can let the developers know if you want to activate groups feature.`}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`By default, we don’t activate groups features until manually requested.`}</li>
      <li parentName="ul">{`Groups features are in beta testing`}</li>
    </ul>
    <_Heading level={2} id={"top-header"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}><Highlight color="#fa383e" mdxType="Highlight"> Top Header </Highlight></_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`This is the place 90% cases where you will see app names, notification icons, chat icons and also search bar`}</li>
      <li parentName="ul">{`If you want to rearrange the placement, it is possible to change based on your request and charged. `}</li>
      <li parentName="ul">{`You need to subscribe growth plan for drastic changes with our developer assistance`}</li>
    </ul>
    <_Heading level={2} id={"super-app-widget"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#1877F2" mdxType="Highlight"> SuperApp Widget </Highlight></_Heading>
    <p>{`SuperApp widget allows to combination of different actions with different objectives. Mostly you would have seen in fin-tech apps, Uber, etc. `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Currently, it needs developer assistance. `}</li>
    </ul>
    <_Heading level={2} id={"navigation-bar-footer"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#1877F2" mdxType="Highlight"> Navigation Bar / Footer </Highlight></_Heading>
    <p>{`The navigation bar in the footer of the app where you can navigate between home, social feed, more section, etc.
`}<img parentName="p" {...{
        "src": "/img/navbar.png",
        "alt": "navbar"
      }}></img></p>
    <_Heading level={2} id={"social-feed"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}><Highlight color="#1877F2" mdxType="Highlight"> Social Feed </Highlight></_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Not possible to customise this. We can deactivate if it’s not needed for you. `}</li>
    </ul>
    <p><img parentName="p" {...{
        "src": "/img/Moresection.png",
        "alt": "Moresection"
      }}></img></p>
    <_Heading level={2} id={"search-screen"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}><Highlight color="#fa383e" mdxType="Highlight"> Search Screen </Highlight></_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Can activate/deactivate the whole feature`}</li>
    </ul>
    <_Heading level={2} id={"branch-invite"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}><Highlight color="#fa383e" mdxType="Highlight"> Branch Invite </Highlight></_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`You can change the brand`}</li>
      <li parentName="ul">{`Cannot be customisable except the branding colours`}</li>
      <li parentName="ul">{`Can deactivate the whole feature`}</li>
    </ul>
    <_Heading level={2} id={"chat-screens"} nextElement={{
      "type": "paragraph"
    }}><Highlight color="#fa383e" mdxType="Highlight"> Chat screens </Highlight></_Heading>
    <p>{`Cannot be customisable except the branding colours`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
